import { KollabHRWatermark } from '@gokrew/ui/assets';
import styles from './Cards.module.css';

interface BGCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  withWatermark?: boolean;
}

export default function BGCard({
  children,
  className = '',
  withWatermark = false,
  ...props
}: BGCardProps) {
  return (
    <div className={`${styles.bgCard} ${className}`} {...props}>
      {withWatermark && (
        <img
          src={KollabHRWatermark}
          className={styles.watermark}
          alt=""
          aria-hidden="true"
        />
      )}
      {children}
    </div>
  );
}
